import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { AuthTokenActions } from '../auth-token/auth-token.actions';
import { LiveChatActions } from '../live-chat/live-chat.actions';
import { MessagesActions } from '../messages/messages.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { AnalyticsEffects } from './analytics.effects';

export const initialState: Readonly<UCXVirtualAssistant> = {
  trigger: {
    id: '',
    name: '',
  },
  queue: '',
  vaSessionId: '',
  responseUuid: '',
};

export const analyticFeature = createFeature({
  name: 'analytics',
  reducer: createReducer(
    initialState,
    on(AuthTokenActions.startSessionSuccess, (state, { sessionIdentifier }) => {
      return { ...state, vaSessionId: sessionIdentifier };
    }),
    on(LiveChatActions.handleCreateChatSuccess, (state, { chatId }) => {
      return { ...state, vaSessionId: state.vaSessionId + '|' + chatId };
    }),
    on(MessagesActions.dialogApiSuccess, (state, { messages }) => {
      const uuidArr = messages.map((message) => message.uuid);
      return { ...state, responseUuid: uuidArr.join('|') };
    })
  ),
});

export const { selectAnalyticsState, selectVaSessionId } = analyticFeature;

export function provideAnalyticsFeature() {
  return makeEnvironmentProviders([
    provideState(analyticFeature),
    provideEffects(AnalyticsEffects),
  ]);
}
